import React, { useState, useEffect, useRef } from 'react'
import { postData, putData } from '../../actions/servicesHttp'
import { useSelector } from 'react-redux'
import $ from 'jquery'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Loading from '../generals/loading'
import { elementsLocked } from './Assets/jsons'
import { Accordion, AccordionTab } from 'primereact/accordion'
import styles from '../../css/modals/Modal.module.css'
import styleschecks from '../../css/generals/Checkbox.module.css'
import PropTypes from 'prop-types'
import { popupSimple } from '../generals/popups'
import { Message } from 'primereact/message'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function LockedDevices ({ preferences, onHide, action, show, key, title, configDefault, devices, socketSendActions, realTime, reload }) {
  const user = useRef()
  const { t } = useTranslation('dashboardDevice')
  const userData = useSelector((state) => state.user)
  const navigate = useNavigate()
  const [id, setId] = useState(
    Math.round(Math.random() * (1000000000000000 - 10 + 1) + 10)
  )
  const [statusMessage, setStatusMessage] = useState(true)
  const [uploadDenunciation, setUploadDenunciation] = useState(false)
  const [file, setFile] = useState(null)
  const [data, setData] = useState({
    alarm: preferences.alarm,
    touch: preferences.touch,
    screen: preferences.screen,
    background: preferences.background,
    /* usb: preferences.usb, */
    /* statusMessage: preferences.statusMessage, */
    messageTitle: preferences?.messageTitle,
    messageBody: preferences?.messageBody,
    photo: {
      status: preferences.photo,
      quality: preferences.quality,
      recursive: preferences.recursive,
      time: preferences.timeImage
    }
  })

  const [tracking, setTracking] = useState({
    statusTracking: preferences.statusTracking,
    tracking: preferences.timeTracking,
    report: preferences.timeRequest
  })

  const [denunciation, setDenunciation] = useState({
    incidentDate: null,
    denunciationDate: null,
    denunciationNumber: null,
    investigator: null,
    file: null,
    fileExtension: null
  })

  const [errorDenunciation, setErrorDenunciation] = useState(false)

  const tomorrow = new Date()

  useEffect(() => {
    user.current = userData?.userId
  }, [userData])

  useEffect(() => {
    if (!statusMessage) {
      setData({
        ...data,
        messageTitle: '',
        messageBody: ''
      })
    }
  }, [statusMessage])

  function handleOnChange (e) {
    if (e.target.type === 'checkbox') {
      const value = $(`#${e.target.id}`).is(':checked')
      if (e.target.id === 'status' || e.target.id === 'recursive') {
        setData({
          ...data,
          photo: {
            ...data.photo,
            [e.target.id]: value
          }
        })
      } else if (e.target.id === 'statusTracking') {
        if (!value) {
          setData({
            ...data,
            photo: {
              ...data.photo,
              status: value
            }
          })
        }
        setTracking({
          ...tracking,
          [e.target.id]: value
        })
      } else {
        setData({
          ...data,
          [e.target.id]: value
        })
      }
    } else {
      if (e.target.id === 'quality' || e.target.id === 'time') {
        setData({
          ...data,
          photo: {
            ...data.photo,
            [e.target.id]: e.target.value
          }
        })
      } else if (e.target.id === 'report' || e.target.id === 'tracking') {
        setTracking({
          ...tracking,
          [e.target.id]: e.target.value
        })
      } else {
        setData({
          ...data,
          [e.target.id]: e.target.value
        })
      }
    }
  }

  function handleOnChangeDenunciation (e) {
    setDenunciation({
      ...denunciation,
      [e.target.id]: e.target.value
    })
  }

  function inputFileHandling () {
    const input = document.querySelector('#denunciationFile')

    input.addEventListener('change', e => {
      const span = document.querySelector('#file_name_document')

      if (input?.files?.length === 0) {
        span.innerHTML = t('modalInforms.label1')
      } else if (input?.files?.length > 0) {
        span.innerHTML = input.files[0].name
        const extension = input.files[0].name.split('.').pop()
        setDenunciation({
          ...denunciation,
          file: input.files[0].name,
          fileExtension: extension
        })
        setFile(input.files)
      }
    })
  }

  const handleInputChangeVisibility = (e, set) => {
    const value = $(`#${e.target.id}`).is(':checked')
    set(value)
  }

  const validationDenunciation = (data, set) => {
    const flag = Object.values(data).some(value => value === null)
    set(flag)
    return flag
  }

  const uploadDenunciationFile = async (licence) => {
    let res
    const f = new FormData()

    if (file !== null) {
      for (let i = 0; i < file.length; i++) {
        const extension = file[i].name.split('.').pop()
        const newName = licence + '_' + denunciation?.denunciationNumber + '.' + extension // Cambia el nombre y mantiene la extensión
        const newFile = new File([file[i]], newName, { type: file[i].type })
        f.append('files', newFile)
      }

      const response = await postData('upload/denunciations', f, navigate)

      if (response?.status === 200) {
        setFile(null)
        res = true
      } else {
        popupSimple('error', t('modalInforms.label2'))
        res = false
      }
    } else {
      popupSimple('info', t('modalInforms.label3'))
      res = false
    }
    return res
  }

  function closeModal () {
    onHide()
    setData({
      alarm: preferences.alarm,
      touch: preferences.touch,
      screen: preferences.screen,
      background: preferences.background,
      /*   usb: preferences.usb,
      statusMessage: preferences.statusMessage, */
      messageTitle: preferences.messageTitle,
      messageBody: preferences.messageBody,
      photo: {
        status: preferences.photo,
        quality: preferences.quality,
        recursive: preferences.recursive,
        time: preferences.timeImage
      }
    })
    setTracking({
      statusTracking: preferences.statusTracking,
      tracking: preferences.timeTracking,
      report: preferences.timeRequest
    })
    setId(Math.round(Math.random() * (1000000000000000 - 10 + 1) + 10))
    setFile(null)
    setDenunciation({
      incidentDate: null,
      denunciationDate: null,
      denunciationNumber: null,
      investigator: null,
      file: null,
      fileExtension: null
    })
    setErrorDenunciation(false)
    setUploadDenunciation(false)
  }

  async function sendAction () {
    $('#btnModalSucess').prop('disabled', true)
    let denunciationFlag
    if (uploadDenunciation) denunciationFlag = validationDenunciation(denunciation, setErrorDenunciation)

    if (action === 'bloquear' && statusMessage && data?.messageTitle === '') {
      popupSimple('info', t('modalInforms.label4'))
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
    } else if (action === 'bloquear' && statusMessage && data?.messageBody === '') {
      popupSimple('info', t('modalInforms.label5'))
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
    } else if (action === 'bloquear' && uploadDenunciation && denunciationFlag) {
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
    } else {
      const dataPreferences = { ...data }

      if (action === 'desbloquear') {
        dataPreferences.messageBody = ''
        dataPreferences.messageTitle = ''
      }

      const json = {
        action: 'lock',
        data: {
          statusLock: action === 'bloquear',
          order_id: id,
          preferences: dataPreferences
        },
        devicesId: [],
        groupsId: [],
        userId: userData.userId
      }

      const jsonTracking = {
        action: 'tracking',
        data: {
          statusTracking: tracking.statusTracking,
          report: tracking.report,
          tracking: tracking.tracking,
          order_id: id
        },
        devicesId: [],
        groupsId: [],
        userId: userData.userId
      }

      let errorFlag = false

      devices?.forEach(async (item) => {
        const flag = !!(action === 'bloquear' && item?.motive_lock === 'disabled' && item?.status_lock === true)

        jsonTracking.devicesId = [item.id]
        json.devicesId = [item.id]

        if (action === 'bloquear') {
          item.motive_lock = 'locked'
          item.reported = !denunciationFlag
        } else if (action === 'desbloquear') {
          item.motive_lock = null
          jsonTracking.data.statusTracking = false
        }

        let response
        const jsonArray = action === 'desbloquear' || tracking.statusTracking ? [json, jsonTracking] : [json]

        if (realTime) {
          socketSendActions(jsonArray)
        } else {
          response = await postData('actions', jsonArray, navigate)
          if (response?.status !== 200) errorFlag = true
        }

        if (uploadDenunciation) {
          let upload = true
          upload = await uploadDenunciationFile(item.licence)

          if (!upload) {
            closeModal()
            setTimeout(() => {
              $('#btnModalSucess').prop('disabled', false)
            }, 1500)
            return
          }
        }

        if ((!errorFlag) || realTime) {
          const putJson = {
            id: [item.id],
            motive_lock: item.motive_lock
          }
          if (flag) {
            putJson.status_lock = false
          } else {
            putJson.reported = item.reported
          }

          await putData('device', putJson, navigate).finally(() => reload())

          if (uploadDenunciation) {
            const response = await postData('denunciations', { ...denunciation, deviceId: item?.id, userId: userData.userId, orderId: id }, navigate)

            if (response?.error) {
              popupSimple('error', t('lockedDevices.label9'))
              setTimeout(() => {
                $('#btnModalSucess').prop('disabled', false)
              }, 1500)
              closeModal()
            }
          }
        }
      })

      if (errorFlag) {
        popupSimple('error', t('lockedDevices.label11'))
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
      } else {
        popupSimple('success', t('lockedDevices.label10'))
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
      }

      closeModal()
    }
  }

  const elements = elementsLocked(data, tracking, statusMessage, denunciation, uploadDenunciation)
  const screenElements = elements.slice(0, 3)
  const alertElements = elements.slice(3, 7)
  const trackingElements = elements.slice(7, 10)
  const denunciationElements = elements.slice(10, 15)

  if (preferences === undefined || preferences === null) {
    <Loading color="primary" />
  } else {
    return (
      <>
        <Modal
          show={show}
          onHide={closeModal}
          size={action === 'desbloquear' ? 'lg' : 'xl'}
          id="deviceLocked"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                textAlign: 'center'
              }}
            >
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className={styles.modalBody}
            style={{
              display:
                configDefault === true || action === 'desbloquear'
                  ? 'none'
                  : 'block'
            }}
          >
            <div className="card">
              <Accordion activeIndex={[0]}>
                <AccordionTab header={t('lockedDevices.label12')}>
                  {screenElements &&
                    screenElements.map((el) => (
                      <div
                        key={el.key}
                        className={styleschecks.containerDiv}
                        style={{
                          justifyContent: 'space-between',
                          display: 'flex'
                        }}
                      >
                        <label className={styleschecks.sliderLabel}>
                          {el.label}
                        </label>
                        <label className={styleschecks.switch}>
                          <input
                            key={key}
                            id={el.id}
                            value={el.value}
                            checked={el.value}
                            name={el.name}
                            onChange={(e) => handleOnChange(e)}
                            type="checkbox"
                            className="focus"
                          />
                          <span
                            className={`${styleschecks.slider} ${styleschecks.round} ${styleschecks.inputsLabels}`}
                          />
                        </label>
                      </div>
                    ))}
                </AccordionTab>
                <AccordionTab header={t('lockedDevices.label13')}>
                  {trackingElements &&
                    trackingElements.map((el) =>
                      el.type === 'checkbox'
                        ? (
                        <div
                          key={el.key}
                          className={styleschecks.containerDiv}
                          style={{
                            justifyContent: 'space-between',
                            display: el.display === false ? 'none' : 'flex'
                          }}
                        >
                          <label className={styleschecks.sliderLabel}>
                            {el.label}
                          </label>
                          <label className={styleschecks.switch}>
                            <input
                              key={key}
                              id={el.id}
                              value={el.value}
                              checked={el.value}
                              name={el.name}
                              onChange={(e) => handleOnChange(e)}
                              type="checkbox"
                              className="focus"
                            />
                            <span
                              className={`${styleschecks.slider} ${styleschecks.round} ${styleschecks.inputsLabels}`}
                            />
                          </label>
                        </div>
                          )
                        : el.type === 'number'
                          ? (
                        <div
                          className={styleschecks.containerDiv}
                          id={`div${el.id}`}
                          style={{
                            justifyContent: 'space-between',
                            margin: '0px 0px 15px 0px',
                            display: el.display === false ? 'none' : 'flex'
                          }}
                        >
                          <div>
                            <label className={styleschecks.sliderLabel}>
                              {el.label}
                            </label>
                            <small className="text-muted">{el.small}</small>
                          </div>
                          <div
                            style={{
                              width: 'fit-content',
                              justifyContent: 'flex-end',
                              display: 'flex'
                            }}
                          >
                            <input
                              key={el.key}
                              placeholder={el.placeholder}
                              id={el.id}
                              name={el.name}
                              value={el.value}
                              onChange={(e) => handleOnChange(e)}
                              type={el.type}
                              style={{ width: '4rem', textAlign: 'center' }}
                              className={styleschecks.focus}
                            />
                          </div>
                        </div>
                            )
                          : el.type === 'options'
                            ? (
                        <div
                          className={styleschecks.containerDiv}
                          style={{
                            display: el.display === false ? 'none' : 'flex',
                            justifyContent: 'space-between'
                          }}
                        >
                          <label className={styleschecks.sliderLabel}>
                            {el.label}
                          </label>
                          <select
                            id={el.id}
                            onChange={(e) => handleOnChange(e)}
                            /* className="form-control" */
                            style={{ width: '280px' }}
                            name="resolution_images"
                            defaultValue={'default'}
                            className={styleschecks.focus}
                            value={el.value}
                          >
                            <option value="default" disabled>
                              {el.default}
                            </option>
                            {el.options &&
                              el.options.map((option) => (
                                <option value={option.value} key={option.title}>
                                  {option.title}
                                </option>
                              ))}
                          </select>
                        </div>
                              )
                            : null
                    )}
                </AccordionTab>
                <AccordionTab header={t('lockedDevices.label14')}>
                  {alertElements &&
                    alertElements.map((el) =>
                      el.type === 'checkbox'
                        ? (
                        <div
                          key={el.key}
                          className={styleschecks.containerDiv}
                          style={{
                            justifyContent: 'space-between',
                            display: 'flex'
                          }}
                        >
                          <label className={styleschecks.sliderLabel}>
                            {el.label}
                          </label>
                          <label className={styleschecks.switch}>
                            <input
                              key={key}
                              id={el.id}
                              value={el.value}
                              checked={el.value}
                              name={el.name}
                              onChange={el.key === 'keyStatusMessage' ? (e) => handleInputChangeVisibility(e, setStatusMessage) : (e) => handleOnChange(e)}
                              type="checkbox"
                              className="focus"
                            />
                            <span
                              className={`${styleschecks.slider} ${styleschecks.round} ${styleschecks.inputsLabels}`}
                            />
                          </label>
                        </div>
                          )
                        : el.type === 'area'
                          ? (
                        <div
                          className={styleschecks.containerDiv}
                          style={{
                            display: el.display === false ? 'none' : 'flex',
                            justifyContent: 'space-between'
                          }}
                        >
                          <div style={{ width: 'auto' }}>
                            <label className={styleschecks.sliderLabel}>
                              {el.label}
                            </label>
                          </div>
                          <div style={{ width: '60%' }}>
                            <textarea
                              key={el.key}
                              style={{ height: '7rem', resize: 'none' }}
                              placeholder={el.placeholder}
                              id={el.id}
                              name={el.name}
                              value={el.value}
                              onChange={(e) => handleOnChange(e)}
                              type={el.type}
                              className={`${styles.inputModal} ${styles.inputUsers} ${styleschecks.focus}`}
                            />
                          </div>
                        </div>
                            )
                          : el.type === 'text'
                            ? (
                        <div
                          className={styleschecks.containerDiv}
                          id={`div${el.id}`}
                          style={{
                            justifyContent: 'space-between',
                            margin: '0px 0px 15px 0px',
                            display: el.display === false ? 'none' : 'flex'
                          }}
                        >
                          <div>
                            <label className={styleschecks.sliderLabel}>
                              {el.label}
                            </label>
                          </div>
                          <div
                            style={{
                              width: '60%',
                              justifyContent: 'flex-end',
                              display: 'flex'
                            }}
                          >
                            <input
                              key={el.key}
                              placeholder={el.placeholder}
                              id={el.id}
                              name={el.name}
                              value={el.value}
                              onChange={(e) => handleOnChange(e)}
                              type={el.type}
                              style={{ width: '100%' }}
                              className={styleschecks.focus}
                            />
                          </div>
                        </div>
                              )
                            : null
                    )}
                </AccordionTab>
                <AccordionTab header={t('lockedDevices.label15')}>
                {denunciationElements &&
                    denunciationElements.map((el) =>
                      el.type === 'checkbox'
                        ? (
                        <div
                          key={`div${el.id}`}
                          className={styleschecks.containerDiv}
                          id={`div${el.id}`}
                          style={{
                            justifyContent: 'space-between',
                            margin: '0px 0px 15px 0px',
                            display: 'flex'
                          }}
                        >
                          <label className={styleschecks.sliderLabel}>
                            {el.label}
                          </label>
                          <label className={styleschecks.switch}>
                            <input
                              key={el.key}
                              id={el.id}
                              name={el.name}
                              value={el.value}
                              checked={el.value}
                              onChange={(e) => handleInputChangeVisibility(e, setUploadDenunciation)}
                              type={el.type}
                              className={styleschecks.focus}
                            />
                            <span
                              className={`${styleschecks.slider} ${styleschecks.round} ${styleschecks.inputsLabels}`}
                            />
                          </label>
                        </div>
                          )
                        : el.type === 'text'
                          ? (
                    <div
                      className={`${styleschecks.containerDiv} ${styleschecks.divColumn}`}
                      id={`div${el.id}`}
                      key={`div${el.id}`}
                      style={{
                        justifyContent: 'space-between',
                        margin: '0px 0px 15px 0px',
                        display: el.display === false ? 'none' : 'flex'
                      }}
                    >
                      <div>
                        <label className={styleschecks.sliderLabel}>
                          {el.label}
                        </label>
                      </div>
                      <div
                        style={{
                          width: 'fit-content',
                          justifyContent: 'flex-end',
                          display: 'flex'
                        }}
                      >
                        <input
                          key={el.key}
                          placeholder={el.placeholder}
                          id={el.id}
                          name={el.name}
                          value={el.value}
                          onChange={(e) => handleOnChangeDenunciation(e)}
                          type={el.type}
                          style={{ width: '14rem', textAlign: 'center' }}
                          className={styleschecks.focus}
                        />
                      </div>
                    </div>
                            )
                          : el.type === 'date'
                            ? (
                            <div
                              key={`div${el.id}`}
                              className={`${styleschecks.containerDiv} ${styleschecks.divColumn}`}
                              id={`div${el.id}`}
                              style={{
                                justifyContent: 'space-between',
                                margin: '0px 0px 15px 0px',
                                display: el.display === false ? 'none' : 'flex'
                              }}
                            >
                              <div>
                                <label className={styleschecks.sliderLabel}>
                                  {el.label}
                                </label>
                                <small className="text-muted">{el.small}</small>
                              </div>
                              <div
                                style={{
                                  width: 'fit-content',
                                  justifyContent: 'flex-end',
                                  display: 'flex'
                                }}
                              >
                                <input
                                  key={el.key}
                                  placeholder={el.placeholder}
                                  id={el.id}
                                  name={el.name}
                                  value={el.value}
                                  onChange={(e) => handleOnChangeDenunciation(e)}
                                  type={el.type}
                                  style={{ width: '14rem', textAlign: 'center' }}
                                  className={styleschecks.focus}
                                  max={tomorrow.toISOString().split('T')[0]}
                                />
                              </div>
                            </div>
                              )
                            : null
                    )}
                      <div
                        key="divDenunciationFile"
                        className={`${styleschecks.containerDiv} ${styleschecks.divColumn}`}
                        id="divDenunciationFile"
                        style={{ justifyContent: 'space-between', margin: '0px 0px 15px 0px', display: uploadDenunciation === false ? 'none' : 'flex' }}
                      >
                        <label className={styleschecks.sliderLabel}>{t('lockedDevices.label16')}</label>
                        <input
                          key="keyDenunciationFile"
                          id="denunciationFile"
                          name="keyDenunciationFile"
                          type="file"
                          accept="image/*,.pdf"
                          className={styles.fancy_file}
                        />
                        <label htmlFor="denunciationFile" className={styles.fancy_file_label} style={{ width: '60%' }}>
                          <span className={styles.fancy_file_button} onClick={() => inputFileHandling() }>
                            <i className="pi pi-download"></i></span>
                          <span className={styles.fancy_file_name}>
                            <span id="file_name_document">{t('lockedDevices.label17')}</span>
                          </span>
                        </label>
                      </div>
                      {errorDenunciation && <Message
                        style={{
                          /* border: 'solid #696cff', */
                          /* borderWidth: '1px 1px 1px 0.5rem', */
                          /* backgroundColor: 'white', */
                          fontWeight: '600',
                          padding: '0.4rem',
                          width: '100%'
                        }}
                        severity="error"
                        text={t('lockedDevices.label18')}
                      />}
                </AccordionTab>
              </Accordion>
            </div>
          </Modal.Body>
          <Modal.Body
            className={styles.modalBody}
            style={{
              display:
                configDefault === true && action === 'bloquear'
                  ? 'block'
                  : 'none'
            }}
          >
            <p style={{ textAlign: 'center' }}> {t('lockedDevices.label19')}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => closeModal()} variant="danger">
              {t('lockedDevices.button1')}
            </Button>
            <Button
              onClick={() => sendAction()}
              variant="primary"
              id="btnModalSucess"
            >
              {t('lockedDevices.button2')}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}

LockedDevices.propTypes = {
  preferences: PropTypes.object,
  onHide: PropTypes.func,
  action: PropTypes.string,
  show: PropTypes.bool,
  key: PropTypes.string,
  title: PropTypes.string,
  configDefault: PropTypes.bool,
  devices: PropTypes.array,
  socketSendActions: PropTypes.func,
  realTime: PropTypes.bool,
  reload: PropTypes.func
}
